import { AvatarImageProps, stateStatusType, } from './actionType';

// FetchVideoGroupSState
export interface FetchAvatarState {
    isLoading: boolean;
    error: string | null;
    avatarsImage: AvatarImageProps[];
    status: stateStatusType | null;
}

export const initialVideoGroupsState: FetchAvatarState = {
    isLoading: false,
    error: null,
    avatarsImage:[],
    status: null,
};

export interface AvatarImageState {
    avatarImageState: FetchAvatarState;
}

export const initialState: AvatarImageState = {
    avatarImageState: initialVideoGroupsState,
};


